import React from 'react';

const playlists = [
  {
    title: 'Video Ads',
    src: 'https://play.gumlet.io/embed/playlist/6a8c015428f2c759010dc7fa'
  },
  {
    title: 'Event Videos',
    src: 'https://play.gumlet.io/embed/playlist/6a954bd010199367b6c70ef7'
  },
  {
    title: 'Product Promo Videos',
    src: 'https://play.gumlet.io/embed/playlist/6a954cd410199367b6c71383'
  }
];

const PortfolioPlaylists = () => {
  return (
    <section className="mb-20">
      <div className="grid grid-cols-1 gap-8">
        {playlists.map((playlist) => (
          <div key={playlist.src}>
            <h2 className="text-xl md:text-2xl font-black text-white uppercase tracking-tight mb-4">
              {playlist.title}
            </h2>
            <div className="relative aspect-[16/9] md:aspect-[80/31] overflow-hidden rounded-2xl bg-zinc-900 border border-white/5">
              <iframe
                loading="lazy"
                title={playlist.title}
                src={playlist.src}
                className="absolute inset-0 h-full w-full border-0"
                referrerPolicy="origin"
                allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture; fullscreen"
              />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PortfolioPlaylists;